(function () {
  function initKaijuQuantityVariantPickers(root = document) {
    const pickers = Array.from(root.querySelectorAll('.kqv'));

    if (!pickers.length) return;

    pickers.forEach((picker) => {
      if (picker.dataset.kqvInitialized === 'true') return;

      const cards = Array.from(picker.querySelectorAll('[data-kqv-card]'));
      if (!cards.length) return;

      picker.dataset.kqvInitialized = 'true';

      const formId = picker.dataset.productFormId;
      const isSizeQuantityMode = picker.dataset.kqvMode === 'size-quantity';

      const getForm = () => {
        return (
          picker.closest('form') ||
          picker.closest('product-form')?.querySelector('form') ||
          (formId ? document.getElementById(formId) : null)
        );
      };

      const getVariantInputs = () => {
        const form = getForm();

        if (!form) return [];

        return Array.from(
          form.querySelectorAll('.product-variant-id, [name="id"]')
        );
      };

      const getSubmitButton = () => {
        const form = getForm();
        return form ? form.querySelector('[name="add"]') : null;
      };

      const getAtcLabel = () => {
        const form = getForm();
        return form ? form.querySelector('.atc-label') : null;
      };

      const getAtcDiscount = () => {
        const form = getForm();
        return form ? form.querySelector('.qty-test-atc__discount') : null;
      };

      const addToCartLabel = picker.dataset.labelAddToCart || 'Add to cart';
      const soldOutLabel = picker.dataset.labelSoldOut || 'Sold out';

      const updateUI = (card, options = {}) => {
        const allowDisabled = options.allowDisabled || false;

        if (!card) return;

        const currentRadio = card.querySelector('input[type="radio"]');

        if (!allowDisabled) {
          if (card.hidden) return;
          if (currentRadio && currentRadio.disabled) return;
          if (card.dataset.available !== 'true') return;
        }

        const variantId = card.dataset.variantId;
        const priceFormatted = card.dataset.priceFormatted || '';
        const compareAtPrice = Number(card.dataset.compareAtPrice || 0);
        const compareAtPriceFormatted = card.dataset.compareAtPriceFormatted || '';
        const discount = Number(card.dataset.discount || 0);
        const isAvailable = card.dataset.available === 'true';

        cards.forEach((item) => {
          item.classList.remove('is-selected');

          const radio = item.querySelector('input[type="radio"]');
          if (radio) radio.checked = false;
        });

        card.classList.add('is-selected');

        if (currentRadio) {
          currentRadio.checked = true;
        }

        const variantInputs = getVariantInputs();

        variantInputs.forEach((input) => {
          input.value = variantId;
          input.disabled = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        const submitBtn = getSubmitButton();

        if (submitBtn) {
          submitBtn.disabled = !isAvailable;
          submitBtn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        }

        const atcLabel = getAtcLabel();

        if (atcLabel) {
          if (isAvailable) {
            atcLabel.innerHTML = `
              <span class="qty-test-atc__main">
                ${addToCartLabel} · <span class="qty-test-atc__price">${priceFormatted}</span>
              </span>
              <span class="qty-test-atc__compare"${compareAtPrice > 0 && compareAtPriceFormatted ? '' : ' hidden'}>
                ${compareAtPrice > 0 && compareAtPriceFormatted ? compareAtPriceFormatted : ''}
              </span>
            `;
          } else {
            atcLabel.textContent = soldOutLabel;
          }
        }

        const atcDiscount = getAtcDiscount();

        if (atcDiscount) {
          if (isAvailable && compareAtPrice > 0 && discount > 0) {
            atcDiscount.textContent = `-${discount}%`;
            atcDiscount.hidden = false;
          } else {
            atcDiscount.textContent = '';
            atcDiscount.hidden = true;
          }
        }
      };

      const initSimpleQuantityPicker = () => {
        cards.forEach((card) => {
          card.addEventListener('click', function (event) {
            event.preventDefault();

            const radio = card.querySelector('input[type="radio"]');

            if (radio && radio.disabled) return;
            if (card.dataset.available !== 'true') return;

            updateUI(card);
          });

          const radio = card.querySelector('input[type="radio"]');

          if (radio) {
            radio.addEventListener('change', function () {
              if (!radio.checked) return;
              if (radio.disabled) return;
              if (card.dataset.available !== 'true') return;

              updateUI(card);
            });
          }
        });

        const selectedCard =
          picker.querySelector('.kqv__card.is-selected:not([hidden])') ||
          cards.find((card) => card.dataset.available === 'true') ||
          cards[0];

        if (selectedCard) {
          updateUI(selectedCard, {
            allowDisabled: selectedCard.dataset.available !== 'true',
          });
        }
      };

      const initSizeQuantityPicker = () => {
        const sizeCards = Array.from(picker.querySelectorAll('[data-kqv-size-card]'));
        const sizeRadios = Array.from(picker.querySelectorAll('[data-kqv-size-radio]'));
        const sizeBadge = picker.querySelector('[data-kqv-size-badge]');

        if (!sizeCards.length || !sizeRadios.length || !cards.length) {
          initSimpleQuantityPicker();
          return;
        }

        const getSelectedQuantityCard = () =>
          cards.find((card) => card.classList.contains('is-selected'));

        const setSize = (sizeValue, preferredPackKey = '12') => {
          sizeCards.forEach((sizeCard) => {
            const isSelected = sizeCard.dataset.sizeValue === sizeValue;
            const radio = sizeCard.querySelector('[data-kqv-size-radio]');

            sizeCard.classList.toggle('is-selected', isSelected);

            if (radio) {
              radio.checked = isSelected;
            }
          });

          const selectedSizeCard = sizeCards.find(
            (sizeCard) => sizeCard.dataset.sizeValue === sizeValue
          );

          if (sizeBadge && selectedSizeCard) {
            sizeBadge.textContent = `${selectedSizeCard.dataset.sizeLabel} per gel`;
          }

          const visibleCards = cards.filter((card) => card.dataset.sizeValue === sizeValue);

          cards.forEach((card) => {
            const shouldShow = card.dataset.sizeValue === sizeValue;
            const radio = card.querySelector('input[type="radio"]');

            card.hidden = !shouldShow;

            if (radio) {
              radio.disabled = !shouldShow || card.dataset.available !== 'true';
              radio.checked = false;
            }

            if (!shouldShow) {
              card.classList.remove('is-selected');
            }
          });

          const nextCard =
            visibleCards.find(
              (card) =>
                card.dataset.packKey === preferredPackKey &&
                card.dataset.available === 'true'
            ) ||
            visibleCards.find(
              (card) =>
                card.dataset.packKey === '12' &&
                card.dataset.available === 'true'
            ) ||
            visibleCards.find((card) => card.dataset.available === 'true') ||
            visibleCards.find((card) => card.dataset.packKey === preferredPackKey) ||
            visibleCards.find((card) => card.dataset.packKey === '12') ||
            visibleCards[0];

          if (nextCard) {
            updateUI(nextCard, {
              allowDisabled: nextCard.dataset.available !== 'true',
            });
          }
        };

        sizeCards.forEach((sizeCard) => {
          sizeCard.addEventListener('click', function (event) {
            event.preventDefault();

            const radio = sizeCard.querySelector('[data-kqv-size-radio]');
            if (!radio) return;

            const currentSelectedQuantity = getSelectedQuantityCard();
            const preferredPackKey = currentSelectedQuantity
              ? currentSelectedQuantity.dataset.packKey
              : '12';

            setSize(radio.value, preferredPackKey);
          });
        });

        sizeRadios.forEach((radio) => {
          radio.addEventListener('change', function () {
            if (!radio.checked) return;

            const currentSelectedQuantity = getSelectedQuantityCard();
            const preferredPackKey = currentSelectedQuantity
              ? currentSelectedQuantity.dataset.packKey
              : '12';

            setSize(radio.value, preferredPackKey);
          });
        });

        cards.forEach((card) => {
          card.addEventListener('click', function (event) {
            event.preventDefault();

            const radio = card.querySelector('input[type="radio"]');

            if (card.hidden) return;
            if (radio && radio.disabled) return;
            if (card.dataset.available !== 'true') return;

            updateUI(card);
          });
        });

        const checkedSizeRadio =
          sizeRadios.find((radio) => radio.checked) ||
          sizeRadios[0];

        const selectedQuantityCard = getSelectedQuantityCard();

        if (checkedSizeRadio) {
          setSize(
            checkedSizeRadio.value,
            selectedQuantityCard ? selectedQuantityCard.dataset.packKey : '12'
          );
        }
      };

      if (isSizeQuantityMode) {
        initSizeQuantityPicker();
      } else {
        initSimpleQuantityPicker();
      }
    });
  }

  function bootKaijuQuantityVariantPickers() {
    initKaijuQuantityVariantPickers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootKaijuQuantityVariantPickers);
  } else {
    bootKaijuQuantityVariantPickers();
  }

  window.addEventListener('load', bootKaijuQuantityVariantPickers);

  document.addEventListener('shopify:section:load', function (event) {
    initKaijuQuantityVariantPickers(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initKaijuQuantityVariantPickers(event.target);
  });

  setTimeout(bootKaijuQuantityVariantPickers, 300);
  setTimeout(bootKaijuQuantityVariantPickers, 1000);
})();